<script lang="ts">
  import type { DistributorSellSheet } from "@shared/types/SellSheet";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Arrow from "@shared/svelte/Components/Arrow.svelte";
  import SellSheetBuy from "@distributor/svelte/SellSheet/Components/SellSheetBuy.svelte";
  import { goto } from "@roxi/routify";

  export let sellSheet: DistributorSellSheet;
  export let pdf: boolean = false;

  const goBack = function () {
    if (window["C"].APP_NAME === "supplier") {
      $goto("/supplier/product_sheets/:productSheetId", { productSheetId: sellSheet.id });
    } else {
      $goto("/distributor/product_sheets/:productSheetId", { productSheetId: sellSheet.id });
    }
  };

  let downloadLink = `/api/distributor/sell_sheets/${sellSheet.id}/download`;

  let downloadImage = window["C"].IMAGE_PATHS["sell-sheet-download.svg"];

  const downloadPdf = function () {
    fetch(downloadLink)
      .then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `sellSheet-${sellSheet.name}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(e => console.error(e));
  };

  if (pdf) {
    // dan.s: Without a timeout CI feature spec will fail with a cryptic error (rack-related)
    setTimeout(() => {
      downloadPdf();
    }, 1000);
  }
</script>

<div class="background-white">
  <div class="grid-container">
    <div class="grid-row align--middle padding-top--smaller padding-bottom--smaller">
      <div class="grid-col c12-12">
        <div class="default-subheader--bold align-center">
          <span class="default-subheader--bold cursor-pointer float-left" on:click={goBack}>
            <Arrow direction="left" /> Back</span
          >
          {#if !pdf}
            <span class="default-body--regular align-right float-right color-grayMedium">
              <Icon type={"Info"} height="15" width="15" extraClassNames="sell-sheet-info-icon" />
              This is a preview of your product sheet. Product links are inactive in preview mode.
            </span>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

{#if !pdf}
  <SellSheetBuy {sellSheet} showProductLinks={false} />
{:else}
  <div class="print_detail_wrapper grid-container" id="printView">
    <div class="grid-row align-center">
      <div
        class="grid-col c12-12 padding--3 sell-sheet-preview-wrapper background-white margin-top--smaller margin-top--small--md"
      >
        <div style="height: 90px;"><img src={downloadImage} alt="download" /></div>
        <div class="s3 color-grayDark margin-top--medium padding-bottom--smaller"
          >Your PDF download is starting soon...</div
        >
      </div>
    </div>
  </div>
{/if}
